import { Component, OnInit, TemplateRef, ViewChild, AfterViewInit } from '@angular/core';
import { ReportService } from '../../../../common/services/Report.service';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { EvsAddressService } from '../../../../common/services/EvsAddress.service';
import * as _ from 'lodash';
import { ExportService } from 'app/common/services/Export.service';

declare var $: any;
declare var Chartist: any;

@Component({
    selector: 'report-contact',
    templateUrl: "contact.template.html",
    styleUrls: ['./report.component.css'],
    providers: [ReportService, EvsAddressService]
})



export class ContactComponent implements OnInit {
    public modelFilter : any = {};
    public list : Array<any> = [];
    public allSex : Array<any> = [];
    public allCity : Array<any> = [];
    public allDistrict : Array<any> = [];
    public allSource : Array<any> = [];
    public filterType : string  = 'min';
    public options_contact : any = {};
    public chart_contact_type: string  = 'column';
    public exportData : any = [];

    constructor(
        private reportService: ReportService,
        private commonService : EvsAddressService,
        private exportService : ExportService,
    ) {
        this.modelFilter = {
            from: moment().add('-30', 'days').format('YYYY-MM-DD HH:mm'),
            to: moment().format('YYYY-MM-DD HH:mm')
        }
    }

    ngOnInit() {
        this.loadData();
    }

    loadData() {
        this.reportService.reportContact(this.modelFilter).subscribe(res => {
            this.list = res.data.contacts;
            let data = _.map(res.data.contacts, e => {
                
                if(this.chart_contact_type == 'pie') return  {
                    name: e.title + ': ' + e.count,
                    y: e.count
                };
                else return [e.title, e.count];
            })

            this.options_contact = {
                xAxis: {
                    type: 'category',
                    labels: {
                        rotation: -45,
                        style: {
                            fontSize: '13px',
                            fontFamily: 'Verdana, sans-serif'
                        }
                    }
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: 'Tổng ' + res.data.total + ' khách hàng' 
                    }
                },
                chart: { type: this.chart_contact_type , height: 500, width: 1200},
                title: { text: 'Tổng ' + res.data.total + ' khách hàng' },
                series: [{
                    name: "Khách hàng",
                    colorByPoint: true,
                    data: data,
                }]
            };
        })
    }

    changeFilterType(type) {
        this.filterType = type;
        if(type == 'max') {
            this.initSex();
            this.initSource();
            this.getCity();
        }else {
            delete this.modelFilter.sources;
            delete this.modelFilter.phone;
            delete this.modelFilter.email;
            delete this.modelFilter.city_id;
            delete this.modelFilter.district_ids;
            delete this.modelFilter.gender;
        }
    }

    refreshFilter(){
        delete this.modelFilter.sources;
        delete this.modelFilter.phone;
        delete this.modelFilter.email;
        delete this.modelFilter.gender;
        delete this.modelFilter.city_id;
        delete this.modelFilter.district_ids;
    }

    initSource() {
        this.allSource = [
            // {
            //     id: 'call',
            //     text: "Gọi điện"
            // },
            // {
            //     id: 'hand',
            //     text: "Tạo phiếu ghi"
            // }        
                        { id: 'web', text: 'Kênh Web' },
                        { id: 'facebook', text: 'Kênh Facebook' },
                        {id: 'hand', text: 'Thêm mới'},
                        { id: 'email', text: 'Kênh Email' },
                        { id: 'zalo', text: 'Zalo' },
                        { id: 'call_inbound', text: 'Khách gọi tới' },
                        { id: 'call_outbound', text: 'Gọi điện ra' },
        ]
    }

    initSex() {
        this.allSex = [
            {
                id: "female",
                text: "Nữ"
            },
            {
                id: "male",
                text: "Nam"
            },
            {
                id: "other",
                text: "Khác"
            }
        ]
    }

    getCity() {
        this.commonService.getCities().subscribe(res => {
            let cityList = [];
            res.data.cities.forEach((c: any) => {
                cityList.push({
                    text: c.name,
                    id: c.id.toString(),
                });
            });
            this.allCity = cityList;
        });
    }

    getDistrict(city_id) {
        this.commonService.getDistrict({city_id: city_id}).subscribe(res => {
            let districtList = [];
            res.data.districts.forEach((c: any) => {
                districtList.push({
                    text: c.name,
                    id: c.id,
                });
            });
            this.allDistrict = districtList;
        });
    }

    
    changeTime(type) {
        let start :any = moment().format('YYYY-MM-DD HH:mm');;
        let end :any = moment().format('YYYY-MM-DD HH:mm');;
        switch(type) {
            case 'year' : {
                // start = moment().startOf('year').format('YYYY-MM-DD HH:mm');
                start = moment().add('-365','days').format('YYYY-MM-DD HH:mm');
                break;
            }
            case 'month' : {
                // start = moment().startOf('month').format('YYYY-MM-DD HH:mm');
                start = moment().add('-30','days').format('YYYY-MM-DD HH:mm');
                break;
            }
            case 'week' : {
                // start = moment().startOf('isoWeek').format('YYYY-MM-DD HH:mm');
                start = moment().add('-7','days').format('YYYY-MM-DD HH:mm');
                break;
            }
            case 'day' : {
                // start = moment().startOf('day').format('YYYY-MM-DD HH:mm');
                start = moment().add('-1','days').format('YYYY-MM-DD HH:mm');
                break;
            }
            case 'hour' : {
                start = moment().add('-1','hours').format('YYYY-MM-DD HH:mm');
                break;
            }
            case 'minute' : {
                start = moment().add('-30','minutes').format('YYYY-MM-DD HH:mm');
                break;
            }
            default : break;
        }
        this.modelFilter['from'] = start;
        this.modelFilter['to'] = end;
        this.loadData();
    }

    submitFilter() {
        if(this.modelFilter.from) this.modelFilter.from = moment(this.modelFilter.from).format('YYYY-MM-DD HH:mm');
        if(this.modelFilter.to) this.modelFilter.to = moment(this.modelFilter.to).format('YYYY-MM-DD HH:mm');
        this.loadData();
    }

    public changeSex(e: any): void {
        this.modelFilter['gender'] = e.value;
    }

    public changeSource(e: any): void {
        this.modelFilter['sources'] = e.value;
    }
    public changeCity(e: any): void {
        if(e.value != this.modelFilter['city_id']) {
            this.modelFilter['city_id'] = e.value;
            this.getDistrict(parseInt(e.value))
        }
    }

    public changeDistrict(e: any): void {
        this.modelFilter['district_ids'] = e.value;
    }

    export() {
        this.exportData = [];
        
        this.list.forEach(data =>{
            var data_json : any = {};
            data_json['STT'] = this.list.indexOf(data) + 1;
            data_json['Nguồn'] = data.title;
            data_json['Số lượng'] = data.count;
            this.exportData.push(data_json);
        })

        this.exportService.exportExcel(this.exportData, 'Báo cáo khách hàng ' + moment(new Date()).format("YYYY-MM-DD HH-mm"));
    }

}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/pages/admin/icontact/report/contact.component.ts